import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setProfile, setProfileLoading, loadProfileFromCache, setPage } from '../Redux/store';
import { supabase } from '../supabase/client';
import { isProfileComplete } from '../data/functions';

/** Loads own profile — cache first, then Supabase. Redirects to profile if incomplete. */
function OwnProfileLoader() {
  const dispatch = useDispatch();
  const authUserId = useSelector((s) => s.user.authUserId);
  const profile = useSelector((s) => s.user.profile);

  useEffect(() => {
    if (!authUserId) return;

    let cancelled = false;

    async function loadProfile() {
      // 1. Load from cache
      dispatch(loadProfileFromCache(authUserId));

      // 2. Fetch fresh from Supabase (keeps cached data if offline)
      try {
        const { data, error } = await supabase
          .from('profiles')
          .select('*')
          .eq('id', authUserId)
          .maybeSingle();

        if (cancelled) return;
        if (error) { return; }


        dispatch(setProfile(data ?? null));
        const firstTimeViews = data?.first_time_views || {};
        if (data && !firstTimeViews.profile_welcome) {
          dispatch(setPage('profile'));
        }
      } catch (err) {
      } finally {
        if (!cancelled) {
          dispatch(setProfileLoading(false));
        }
      }
    }

    loadProfile();
    return () => { cancelled = true; };
  }, [dispatch, authUserId]);

  // Redirect if profile setup is incomplete (works for cached data too)
  useEffect(() => {
    const firstTimeViews = profile?.first_time_views || {};
    if (profile && !firstTimeViews.profile_welcome) {
      dispatch(setPage('profile'));
    }
  }, [profile, dispatch]);

  return null;
}

export default OwnProfileLoader;
